<template>
  <div>
    <div class="vx-row">
      <div class="vx-col mb-base">
        <vx-card
          class="p-3"
          title="Impressum"
          title-color="black"
          subtitle="">

          <p>Die Software „ELSI-SAT“ ist das Ergebnis eines vom Bundesministerium für Bildung und Forschung (BMBF) geförderten Forschungsprojekts, das an der Hochschule der Medien (HdM) in Stuttgart vom dortigen Institut für digitale Ethik (IDE) im Zeitraum von Frühjahr 2019 bis Herbst 2020 durchgeführt wurde.</p>
          <br>
          <p>Die Hochschule der Medien (HdM) ist eine Körperschaft des öffentlichen Rechts und wird gesetzlich vertreten durch ihren Rektor Prof. Dr. Alexander W. Roos. Datenschutzbeauftragter: Prof. Dr. Roland Schmitz</p>
          <br>
          <p>Hochschule der Medien </p>
          <p>Nobelstr. 10</p>
          <p>70569 Stuttgart</p>
          <br>
          <p>Tel.: 0711/ 8923 - 10</p>
          <p>Fax: 0711/ 8923 - 11</p>
          <p>www.hdm-stuttgart.de</p>
          <br>
          <h6 class="mt-5 mb-4">Zuständige Rechtsaufsichtsbehörde:</h6>
          <p> </p>
          <p>Ministerium für Wissenschaft, Forschung und Kunst Baden-Württemberg (MWK)</p>
          <p>Königstraße 46</p>
          <p>70173 Stuttgart</p>
          <br>
          <p>Tel.: 0711/ 279 - 0</p>
          <p>Fax: 0711/ 279 - 3080</p>
          <p>www.mwk.bwl.de</p>
          <p>poststelle@mwk.bwl.de</p>
          <br>
          <p>Forschungsleitende Projektverantwortung:</p>
          <br>
          <p>Institut für digitale Ethik (IDE)</p>
          <p>- Prof. Dr. Tobias O. Keber -</p>
          <br>
          <p>Tel.: 0711/ 8923 - 2299</p>
          <p>https://www.hdm-stuttgart.de/digitale-ethik/home</p>
          <p>ide@hdm-stuttgart.de</p>

          <br>
          <h5 class="mt-5 mb-4">Haftungsausschluss</h5>
          <h6 class="mt-5 mb-4">1. Inhalt des Angebots</h6>
          <p>Die Autoren und Verantwortlichen übernehmen keine Gewähr für die Aktualität, Korrektheit und Vollständigkeit der bereitgestellten Informationen. Die Haftung für Schäden materieller oder immaterieller Art, welche aufgrund einer Nutzung/Nichtnutzung dieser Informationen entstehen können, wird grundsätzlich ausgeschlossen, sofern kein vorsätzliches oder grob fahrlässiges Verhalten vorliegt und nachweisbar ist.</p>
          <p>Das Angebot ist freibleibend und unverbindlich. Autoren/Verantwortliche behalten sich vor, Teile der Seiten oder das gesamte Angebot ohne besondere Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen. Unterbrechungen oder anderweitige Störungen, die z.B. durch fehlerhaft angelegte Dateien oder falsch strukturierte Formate bedingt sind, können nicht ausgeschlossen werden.</p>

          <h6 class="mt-5 mb-4">2. Verweise und Links</h6>
          <p>Im Fall von direkten oder indirekten Verweisen auf fremde Inhalte ("Links") kommt eine Haftungsverpflichtung nur dann in Betracht, wenn eine positive Kenntnis der für dieses Angebot Verantwortlichen hinsichtlich der angeblich rechtswidrigen Inhalte vorliegt und es technisch, faktisch und zeitlich möglich und zumutbar ist, eine Nutzung zu verhindern.</p>
          <p>Die Verfasser haben bei erstmaliger Verknüpfung den fremden Inhalt daraufhin überprüft, ob durch diesen eine zivil- oder strafrechtliche Verantwortlichkeit ausgelöst werden könnte. Es werden jedoch Inhalte, auf die das Angebot verweist, nicht ständig auf Veränderungen, die eine Verantwortlichkeit neu begründen könnten, überprüft. </p>
          <p>Wenn festgestellt oder von Nutzern darauf hingewiesen wird, dass ein konkretes Angebot, zu dem ein Link gesetzt ist, eine zivil- oder strafrechtliche Verantwortung auslösen könnte, wird der Verweis auf dieses Angebot aufgehoben.</p>

          <h6 class="mt-5 mb-4">3. Urheberrecht</h6>
          <p>Inhalte und Strukturen des Angebots sind als „Open-Access“-Anwendung ausgestaltet und öffentlich verfügbar, trotzdem besteht ein urheber- und leistungsschutzrechtlicher Schutz. Die Veröffentlichung über Webseiten im „World Wide Web“ oder sonstigen Diensten des Internet ist keine Einverständniserklärung für eine andere als die vorgesehene Nutzung (eigener Download, Export an Projektbeteiligte, Einreichung mit Förderantrag) durch Dritte. Jede darüber hinaus gehende und nach deutschem Urheberrecht unzulässige Verwertung bedarf der vorherigen schriftlichen Zustimmung der Autoren und Verantwortlichen (s.o.).</p>
          <br>
          <p>Wir erlauben und begrüßen ausdrücklich das Zitieren unserer Dokumente sowie das Setzen von Links oder Hinweisen auf unser Angebot, solange kenntlich gemacht wird, dass es sich um Inhalte der oben genannten Verantwortlichen handelt und betreffende Inhalte nicht in Verbindung mit Inhalten Dritter gebracht werden, die den Interessen jener widersprechen.</p>

          <h6 class="mt-5 mb-4">4. Sonstige Hinweise</h6>
          <p>Aus Gründen der besseren Lesbarkeit wurde in den Texten dieses Angebots grundsätzlich auf die gleichzeitige Verwendung männlicher und weiblicher Sprachformen oder sonstiger sprachlicher Wendungen, die auch weitere Geschlechterzugehörigkeiten miteinbeziehen (z.B. „Gendersternchen“), verzichtet. Die grammatikalische Maskulin-Form umfasst daher sämtliche Genderformen und ist unterschiedslos auf alle Personen bezogen.</p>

          <h6 class="mt-5 mb-4">5. Bildnachweise</h6>
          <p>Die Grafik ist mit dem Template des Autors Craftwork der Figma Community erstellt worden (Template: Stubborn Constructor; Online unter: https://www.figma.com/@craftwork).</p>
          <p>Die Icons stammen von verschiedenen Autoren der Webseite iconify (https://iconify.design/icon-sets/), deren Autorennamen und Lizenzen nachfolgend aufgelistet sind: Kompass-Icon (Icons8, Good Boy License, https://icons8.com/good-boy-license), Waage-Icon (Vaadin, CC BY 4.0, https://creativecommons.org/licenses/by/4.0/), Export-Icon (IBM, Apache 2.0), Radar-Chart-Icon (HeskeyBaozi, MIT), Buch-Icon (Atisa, CC 4.0). </p>

        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Impressum"
  }
</script>

<style scoped>

</style>
